import { API_CONFIG } from '@/config/api'

export const chatService = {
  async sendMessage(messages, retryCount = 3) {
    try {
      const response = await fetch(API_CONFIG.DEEPSEEK_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_CONFIG.DEEPSEEK_API_KEY}`
        },
        body: JSON.stringify({
          model: API_CONFIG.MODEL,
          messages: [
            ...messages.map(msg => ({
              role: msg.isAI ? 'assistant' : 'user',
              content: msg.content
            })),
            {
              role: "system",
              content: `你是一位友善、有耐心的学习助手，专为初中生设计，你需要给出解题的思路和过程。在回答问题时，需要遵循以下原则：
                1. 使用简单、易懂的语言，避免使用过于复杂的术语。
                2. 鼓励学生独立思考。
                3. 强调学习过程的重要性，而不是仅仅得到正确答案。
                4. 在适当的时候给与鼓励和正面反馈。
                5. 鼓励学生提出更多问题，培养他们的好奇心。
                6. 在解释时，尽量使用图标，类比等故事增加趣味性。
                记住，你的目标是帮助学生理解问题，学会如何学习，而不仅仅是提供信息。`
            }
          ],
          temperature: 0.7,
          max_tokens: 2000,
          stream: false // 明确指定不使用流式响应
        })
      })

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}))
        throw new Error(
          `API error: ${response.status} - ${errorData.error?.message || response.statusText}`
        )
      }

      const data = await response.json()
      if (!data.choices?.[0]?.message?.content) {
        throw new Error('Invalid API response format')
      }

      return data.choices[0].message.content

    } catch (error) {
      console.error('Chat API error:', error)
      
      // 如果是网络错误并且还有重试次数，则重试
      if (error.name === 'TypeError' && retryCount > 0) {
        console.log(`Retrying... ${retryCount} attempts left`)
        await new Promise(resolve => setTimeout(resolve, 1000)) // 等待1秒后重试
        return this.sendMessage(messages, retryCount - 1)
      }

      // 返回用户友好的错误消息
      throw new Error(
        error.message === 'Failed to fetch'
          ? '网络连接失败，请检查您的网络连接'
          : '抱歉，服务暂时不可用，请稍后再试'
      )
    }
  }
} 